import { PillButtonProps } from './PillButton.interface'
import css from './PillButton.module.css'

export const styles = {
    pillButton: css['pill-button'],
    variant: (variant: PillButtonProps['variant']) => css[`pill-button__${variant}`]
}